import React from "react";
import VendorDashboardStat1 from "../assets/icons/VendorDashboardStat1";
import BriefCaseIcon from "../assets/icons/BriefCaseIcon";
import VendorDashboardStat2 from "../assets/icons/VendorDashboardStat2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const formatIndianCurrencyShort = (amount) => {
  if (typeof amount !== "number" || isNaN(amount)) return "0";

  if (amount >= 10000000) {
    return `${(amount / 10000000).toFixed(2)} Cr`;
  } else if (amount >= 100000) {
    return `${(amount / 100000).toFixed(2)} L`;
  } else if (amount >= 1000) {
    return `${(amount / 1000).toFixed(1)} K`;
  } else {
    return amount.toString();
  }
};

const VendorDashbardStats = () => {
  const { totalPaymentAmount } = useSelector(
    (state) => state.vendorDashboard?.vendorDashboardData
  );

  const totalClusters = useSelector(
    (state) => state.vendorDashboard?.vendorDashboardData?.data || []
  );
  const navigate = useNavigate();
  const stats = [
    {
      id: 1,
      icon: <VendorDashboardStat1 />,
      title: "On Time Jobs",
      value: "97%",
      description: "",
    },
    {
      id: 2,
      icon: <BriefCaseIcon />,
      title: "Total Clusters",
      value: `${totalClusters.length || 0}`,
      description: "",
    },
    {
      id: 3,
      icon: <VendorDashboardStat2 />,
      title: "Estimated Earnings",
      value: `₹ ${formatIndianCurrencyShort(totalPaymentAmount)}`,
      description: "",
    },
  ];

  return (
    <div className=" overflow-x-auto">
      <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-5 m-2 lg:gap-10 justify-center items-center min-w-max">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="bg-white  shadow-lg rounded-2xl p-4 min-w-[250px]  flex items-center justify-between w-auto h-auto relative"
          >
            <div>
              <p className="text-gray-800  font-semibold w-32 text-2xl flex items-center justify-between gap-2">
                {stat.value}
              </p>
              <p className="text-gray-400 text-sm">{stat.title}</p>
            </div>

            <div className=" w-12 h-12 flex justify-center ">{stat.icon}</div>
          </div>
        ))}

        <div
          className=" shadow-[0_10px_25px_rgba(0,0,0,0.15)] rounded-2xl flex flex-col relative p-4"
          style={{
            background:
              "linear-gradient(90deg, rgba(148,169,255,1) 0%, rgba(65,140,255,1) 35%)",
          }}
        >
          <div className="flex justify-between items-center">
            <div className=" flex flex-col justify-center ">
              <p className="text-white text-2xl">Jobs</p>
              <div
                onClick={() => navigate("/vendorportal/jobs/ongoing")}
                className=" flex justify-center items-end gap-2 cursor-pointer"
              >
                <span className=" text-white text-base">View</span>
                <img
                  src="/assests/images/Campaigndash/arrow-up-right.png"
                  alt="pending"
                  className="w-5 h-5 object-cover"
                />
              </div>
            </div>

            <img
              src="/assests/vendorPortalImages/vendorDashboardStat4.png"
              alt="pending"
              className="w-12 h-12 object-cover "
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDashbardStats;
